import { useCallback } from 'react';

import { settle } from '../request';

// Sends one GraphQL operation and settles with its data. GraphQL answers 200
// even when it refuses, so the errors array is what decides: the first error's
// sentence becomes the rejection, ready to show to the person.
export function useGraphql() {
  return useCallback(function({ document, variables }) {
    return settle(fetch('/graphql', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: document, variables })
    }));
  }, []);
}
